import {
	useGetAllAccountingProfilesLazyQuery,
	useDeleteAccountingProfileMutation,
	AccountingProfile,
	PageInfo,
} from "@repo/server-api";
import { useState } from "react";

import { DataSource } from "@repo/legacy/components/shared/lists/DataSource";
import { PaginationModel } from "@repo/legacy/components/shared/lists/PaginationModel";

export function useAllBillingProfilesDataSource(): DataSource<AccountingProfile> {
	const [rows, setRows] = useState<AccountingProfile[]>([]);
	const [rowCount, setRowCount] = useState(0);
	const [isLoading, setIsLoading] = useState(false);
	const [, setPageInfo] = useState<PageInfo | null>(null);
	const [searchBy, setSearchBy] = useState<string>("");
	const [pageModal, setPageModal] = useState<PaginationModel>({
		page: 0,
		pageSize: 10,
	});

	const [deleteBillingAccount] = useDeleteAccountingProfileMutation({
		onCompleted(data: { deleteAccountingProfile: { boolean: boolean } }) {
			if (data.deleteAccountingProfile.boolean) {
				refresh();
			}
		},
	});

	const [getBillingAccounts] = useGetAllAccountingProfilesLazyQuery({
		fetchPolicy: "no-cache",
		onCompleted(data: {
			allAccountingProfiles: {
				nodes: AccountingProfile[];
				totalCount: number;
				pageInfo: PageInfo;
			} | null;
		}) {
			setIsLoading(false);
			if (data && data.allAccountingProfiles) {
				setRows(data.allAccountingProfiles.nodes as AccountingProfile[]);
				setRowCount(data.allAccountingProfiles.totalCount);
				setPageInfo(data.allAccountingProfiles.pageInfo);
				setIsLoading(false);
			}
		},
	});

	const refresh = () => {
		fetchData(pageModal, searchBy);
	};

	const fetchData = (page: PaginationModel, searchBy: string) => {
		setIsLoading(true);
		setSearchBy(searchBy);
		setPageModal(page);
		getBillingAccounts({
			variables: {
				first: page.pageSize,
				after: (page.pageSize * page.page).toString(),
				name: searchBy,
			},
		}).then(
			(response: {
				data: {
					allAccountingProfiles: {
						nodes: AccountingProfile[];
						totalCount: number;
						pageInfo: PageInfo;
					} | null;
				};
			}) => {
				if (response.data && response.data.allAccountingProfiles) {
					setRows(response.data.allAccountingProfiles.nodes as AccountingProfile[]);
					setRowCount(response.data.allAccountingProfiles.totalCount);
					setPageInfo(response.data.allAccountingProfiles.pageInfo);
					setIsLoading(false);
				}
			},
		);
	};

	const deleteData = (id: string) => {
		deleteBillingAccount({ variables: { id } });
	};

	return {
		rows,
		rowCount,
		isLoading,
		fetchData,
		deleteData,
		refresh,
	};
}
